import { PAGES } from '$lib/utils/constants.js';
import { openModal } from 'svelte-modals';
import ModalDNSMI from '$lib/components/modals/ModalDNSMI.svelte';

/**
 * @type {import('./index.js').HomePageConfiguration}
 */
const config = {
	homeHeaderContent: {
		loginBtnTxt: 'Conectarse',
		logoutBtnTxt: 'Desconectarse',
		signUpBtnTxt: 'Registrarse'
	},
	heroSectionContent: {
		title: 'El programa de aprendizaje en línea <span>n.º1</span>',
		subTitle: 'para niños de entre 2 y 8 años*',
		offer: '¡Obtén el primer mes gratis!',
		offerDisclaimer: 'Luego solo $14.99/mes hasta que se cancele.',
		cta: '¡Comencemos!',
		subTitleDisclaimer: `*La aplicación educativa para niños más descargada`,
		offerBadgeImgSrc: '',
		offerBadgeImgAltTxt:
			'Click to Learn about our Special Annual Offer. Get up to 70% off our monthly pricing! $45.00 per year until canceled',
		subjectListItems: ['Lectura', 'Matemáticas', 'Ciencia', 'Arte y Colores', 'Música']
	},
	learningPathSectionContent: {
		superHeroImgSrc: '',
		superHeroImgAltTxt: '3 superheros',
		titleOne: 'Aprende más',
		titleTwo: 'sobre ABCmouse',
		videoThumbnailImgSrc: '',
		videoThumbnailAltTxt: 'A girl playing abcmouse on a computer with her dad.',
		learningPathStarImgSrc: '',
		learningPathStarAltTxt: 'Star and the end of a path',
		learningPathTitle: 'El Camino del Aprendizaje<br/>Paso a Paso',
		learningPathExplainer: `¡Desbloquea el potencial de aprendizaje de tu niño con El Camino del Aprendizaje Paso a Paso! Sumérgete en el currículo completo de ABCmouse, que cuenta con más de <span>850 emocionantes lecciones</span> en <span>10 niveles</span>. ¡Ve cómo tu niño avanza mientras se ve motivado en cada paso por nuestro divertido Sistema de Boletos y Recompensas!`,
		learningPathImgSrc: '',
		learningPathImgAltTxt: 'Abc Mouse in a school bus traveling down the learning path.',
		quotationMarksImgSrc: '',
		quotationMarksAltTxt: 'Quotation marks',
		testimonials: [
			{
				title: '¡ABCmouse es increíble!',
				content: `Mis niñas están muy entusiasmadas en aprender y no quieren parar. Estoy muy contenta de haber tomado la decisión de invertir en la educación de mis hijas al registrarme en ABCmouse. ¡Gracias! ¡Soy una mamá feliz!`,
				credit: '—Madre de niñas de 3 y 5 años'
			},
			{
				title: '¡A mi hijo le encanta ABCmouse!',
				content: `ABCmouse cuenta con una gran variedad de actividades de aprendizaje para mantener interesado a mi niño. Fue una idea brillante incluir un sistema de recompensas tan divertido. No sé quién a quién le gusta más a ABCmouse... ¡a él o a mí!`,
				credit: '—Madre de un niño de 3 años'
			}
		],
		sectionFooterMbImgSrc: '',
		sectionFooterMbImgAltTxt: `Mom's Choice Gold Award Teacher's Choice Gold Award Parent's Choice Gold Award America's Most Downloaded Kids' Education App of All Time`,
		sectionFooterDtImgSrc: '',
		sectionFooterDtImgAltTxt: `Mom's Choice Gold Award Teacher's Choice Gold Award Parent's Choice Gold Award America's Most Downloaded Kids' Education App of All Time`
	},
	subjectsSectionContent: {
		subjectsIconImgSrc: '',
		subjectsIconImgAltTxt: 'Pencil icon',
		subjectsSectionTitle: 'Materias',
		subjects: [
			{
				imgSrc: '',
				imgSrcAltTxt: 'cat on a skateboard',
				title: 'Lectura y Artes del Lenguaje',
				content: `El currículo de lectura de ABCmouse abarca todo el rango de lectura temprana e incluye fonética, reconocimiento de letras, partes del discurso y más.`
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'ABC mouse doing math',
				title: 'Números y matemáticas',
				content: `ABCmouse enseña números, suma y resta, formas, patrones, medidas y más, a través de juegos divertidos y actividades creativas.`
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'scientist',
				title: 'El Mundo Alrededor',
				content: `El currículo de ciencias y estudios sociales de ABCmouse ayuda a los niños a entender el mundo en el que viven y fomenta la curiosidad.`
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'art brush',
				title: 'Arte y Colores',
				content: `El programa de dibujo y pintura de ABCmouse brinda a los niños la oportunidad de usar líneas, formas y colores para crear obras de arte originales.`
			}
		]
	},
	homeschoolSectionContent: {
		homeschoolIconImgSrc: '',
		homeschoolIconImgAltTxt: 'Award icon',
		homeschoolSectionTitleOne: 'Recursos Galardonados',
		homeschoolSectionTitleTwo: 'para la educación en el hogar',
		homeschoolSubTitle: '¡Uno de los mejores recursos de educación en el hogar para el niño!',
		homeschoolContentOne: `El currículo de alta calidad de ABCmouse tiene miles de actividades de aprendizaje para apoyar la educación del niño en casa.`,
		homeschoolContentTwo: `El currículo complementario de educación en el hogar de ABCmouse, respaldado por investigaciones y diseñado en colaboración con expertos en educación infantil reconocidos a nivel nacional, incluye lo siguiente:`,
		curriculumListItems: [
			{
				imgSrc: '',
				imgSrcAltTxt: 'Libros',
				title: 'Libros'
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'Juegos',
				title: 'Juegos'
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'Videos educativos',
				title: 'Videos educativos'
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'Rompecabezas',
				title: 'Rompecabezas'
			},
			{
				imgSrc: '',
				imgSrcAltTxt: '¡Y más!',
				title: '¡Y más!'
			}
		]
	},
	activitiesSectionContent: {
		activitiesIconImgSrc: '',
		activitiesIconImgAltTxt: 'Award icon',
		activitiesSectionTitle: 'Actividades',
		activities: [
			{
				imgSrc: '',
				imgSrcAltTxt: 'animation',
				title: 'Animación',
				content: `El currículo de ABCmouse incluye cientos de actividades animadas sumamente entretenidas, y cada una de ellas enseña un tema de aprendizaje específico. Desde Prospector Paul, que descubre nuevas combinaciones de letras, hasta King Grammar, que explica los nombres propios a sus aldeanos, estos videos animados entretienen a los niños mientras aprenden.`
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'Juegos',
				title: 'Juegos',
				content: `ABCmouse ofrece cientos de juegos divertidos e interactivos, cada uno diseñado para enseñar un concepto educativo específico. El niño puede jugar para aprender el alfabeto, encontrar nuevas palabras, practicar números y formas, e incluso aprender sobre los planetas. Como todos los juegos en el sitio incluyen instrucciones de audio, hasta los niños pequeños pueden entender y disfrutar fácilmente.`
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'Libros',
				title: 'Libros',
				content: `Con más de 450 historias tradicionales y originales y libros de no ficción, la biblioteca de ABCmouse abre la puerta a mundos de conocimiento, aventura y diversión para los niños. Cada tema de nuestro currículo, ya sea el sonido de una letra, contar del 1 al 100, las cuatro estaciones del año o las regiones de los Estados Unidos, se explica en un lenguaje adecuado para los niños en uno de nuestros libros de la biblioteca.`
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'Canciones',
				title: 'Canciones',
				content: `La colección de música de ABCmouse ofrece canciones originales sobre cada letra del abecedario y muchos otros temas de nuestro currículo, así como canciones infantiles clásicas producidas y grabadas recientemente. La variedad de música en nuestro sitio no solo refuerza las otras materias, sino que también introduce a los niños a una variedad de estilos y temáticas musicales. ¡Al niño le encantará cantar a la par!`
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'Rompecabezas',
				title: 'Rompecabezas',
				content: `Encuentra cientos de rompecabezas y rompecabezas recortables diseñados para ayudar a desarrollar habilidades de resolución de problemas y de razonamiento crítico. Los rompecabezas también ayudan a los niños a recordar ideas y habilidades importantes en la lectura, las matemáticas, las ciencias, el arte, los estudios sociales y la música. Hay rompecabezas para cada letra del abecedario, palabras de uso frecuente, cuentos, números, formas, animales, el sistema de numeración decimal, elementos de cuentos de ficción y muchos, muchos temas más.`
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'Arte',
				title: 'Arte',
				content: `Con una abundancia de diferentes tipos de actividades de arte (incluidas páginas para colorear, punto a punto, pintar por números, trazables e imprimibles), ABCmouse ayuda a los niños a aprender lectura, matemáticas y otras materias mientras se expresan artísticamente.`
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'Imprimibles',
				title: 'Imprimibles',
				content: `ABCmouse tiene más de 2,000 actividades imprimibles en áreas como la lectura, las matemáticas, y el arte y los colores, entre otras. Alentamos a los niños a continuar su aprendizaje cuando no están conectados a la computadora, con actividades imprimibles que incluyen trazado de letras y números, colorear, dibujos para unir puntos, dibujos para pintar por números, laberintos y actividades para reconocer patrones.`
			}
		]
	},
	featuresSectionContent: {
		featuresIconImgSrc: '',
		featuresIconImgAltTxt: 'School bus icon',
		featuresSectionTitle: 'Más funciones',
		features: [
			{
				imgSrc: '',
				imgSrcAltTxt: 'progresso',
				title: 'Reporte del Progreso',
				content: `Es fácil ver cuánto está progresando el niño con el Reporte del Progreso de ABCmouse. Además de mostrar el número total de actividades de aprendizaje completadas en cada categoría (los libros, las canciones, los rompecabezas, los juegos y el arte), hay gráficos fáciles de leer que muestran el progreso por nivel académico y por materia del currículo.`
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'tickets',
				title: 'Boletos y Recompensas',
				content: `ABCmouse anima a los niños a que completen las actividades de aprendizaje recompensándolos con boletos. Los boletos se pueden usar para “comprar” artículos virtuales en el sitio, como un nuevo pez para el salón de clase. El Sistema de Boletos y Recompensas hace del aprendizaje un juego y también enseña habilidades importantes de matemáticas, ya que los niños llevan un registro de los boletos ganados y gastados.`
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'avatar',
				title: 'Avatar Personalizable',
				content: `El avatar es un personaje que el niño puede escoger para representar mientras esté en ABCmouse. Hay una selección extensa de facciones de avatar y ropa, además de otros artículos relacionados con el avatar que se pueden adquirir con los boletos. `
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'Zoológico',
				title: 'Zoológico Interactivo',
				content: `El Zoológico de ABCmouse permite a los niños interactuar con animales de zoológico realistas, incluidos elefantes, leones, monos, cebras, pingüinos, ¡y más! Aprenden datos sobre cada animal y leen libros, juegan juegos, y arman rompecabezas y hacen actividades artísticas para cada uno.`
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'Acuario',
				title: 'El Acuario',
				content: `Tu niño puede escoger exóticos peces tropicales y otros artículos para poner dentro del acuario del salón de clase y, a la vez, aprender muchos hechos interesantes sobre los peces.`
			},
			{
				imgSrc: '',
				imgSrcAltTxt: 'Granja',
				title: 'Granja Interactiva',
				content: `La Granja Interactiva de ABCmouse tiene caballos, gallinas, vacas, ¡y más! Los niños pueden ver las hermosas animaciones de nuestros animales de granja, aprender datos divertidos e interesantes sobre cada uno y hacer actividades relacionadas con la granja.`
			}
		]
	},
	primaryFooterContent: {
		links: [
			{
				id: 'trade-mark',
				text: 'TM & © 2007-2025 Age of Learning, Inc. All rights reserved.<br />',
				href: PAGES.EXTERNAL.AOFL,
				aria: 'Age of Learning Inc. Copyright Notice',
				target: '_blank',
				rel: 'noopener noreferrer'
			},
			{
				id: 'terms-conditions',
				text: 'Términos y condiciones',
				href: PAGES.EXTERNAL.TERMS_CONDITIONS,
				aria: 'Terms and Conditions',
				target: '_blank',
				rel: 'noopener noreferrer'
			},
			{
				id: 'privacy-policy',
				text: 'Política de privacidad',
				href: PAGES.EXTERNAL.PRIVACY_POLICY,
				aria: 'Privacy Policy',
				target: '_blank',
				rel: 'noopener noreferrer'
			},
			{
				id: 'do-not-sell',
				text: 'No vender mi información personal',
				href: '#do-not-sell',
				aria: 'Do Not Sell My Personal Information',
				type: 'callback',
				callback: () =>
					openModal(ModalDNSMI, {
						modalImageSrc: '/assets-mkt/template/cookie-consent-modal/abc_logo-v1.png'
					})
			},
			{
				id: 'customer-support',
				text: 'Asistencia',
				href: PAGES.EXTERNAL.CUSTOMER_SUPPORT,
				aria: 'Customer Care Support',
				target: '_blank',
				rel: 'noopener noreferrer'
			}
		]
	}
};

export default config;
